import { combineReducers } from 'redux';
import user from './user';
import auth from './auth';
import header from './header';
import subheader from './subheader';
import open_menu from './open_menu';
import sidebar from './sidebar';
import plan_user from './plan_user';
import pending_lawyer from './pending_lawyer';

export const reducer = combineReducers({
  user,
  auth,
  header,
  subheader,
  open_menu,
  sidebar,
  plan_user,
  pending_lawyer,
});

export type RootState = ReturnType<typeof reducer>;

export default reducer;
